import React from 'react';
import { MailIcon, MapPinIcon, PhoneIcon } from 'lucide-react';
import { company } from '../data/site';
const footerLinks = [{
  label: 'Home',
  href: '#home'
}, {
  label: 'About',
  href: '#about'
}, {
  label: 'Services',
  href: '#services'
}, {
  label: 'Contact',
  href: '#contact'
}];
export function Footer() {
  return <footer className="bg-charcoal-900 pb-8 pt-16" data-id="element-133" data-mp="36q93x72nl0s4">
      <div className="mx-auto max-w-container px-5 lg:px-8" data-id="element-134" data-mp="3ufa4671c15mb">
        <div className="grid gap-10 border-b border-white/10 pb-10 lg:grid-cols-[1.4fr_1fr_1fr] lg:gap-16" data-id="element-135" data-mp="3uftm3nqzfu0c">
          <div data-id="element-136" data-mp="36mtcl0px0t0">
            <img src={company.logoUrl} alt="CoPro Services logo" className="h-11 w-auto brightness-0 invert" data-id="element-137" data-mp="3lecaoioisghz" />
            <p className="mt-6 text-lg font-bold tracking-tight text-white" data-id="element-138" data-mp="3qbvnrf9hen8c">
              {company.tagline}
            </p>
            <p className="mt-3 max-w-sm text-sm leading-relaxed text-charcoal-400" data-id="element-139" data-mp="2a1jlnfn4665m">
              Commercial painting, industrial cleaning and property services for
              businesses across Orlando and Central Florida.
            </p>
          </div>

          <nav aria-label="Footer" data-id="element-140" data-mp="3gbqzykwgyvdj">
            <h2 className="text-xs font-bold uppercase tracking-[0.14em] text-charcoal-400" data-id="element-141" data-mp="3gctqgrpvqvsx">
              Navigation
            </h2>
            <ul className="mt-5 space-y-3" data-id="element-142" data-mp="3q83s3ecd9166">
              {footerLinks.map(link => <li key={link.href} data-id="element-143" data-mp="82qthw25bzvb">
                  <a href={link.href} className="text-[15px] font-semibold text-charcoal-200 transition-colors duration-150 ease-out hover:text-white" data-id="element-144" data-mp="81pe5fe3kr7s">
                    {link.label}
                  </a>
                </li>)}
            </ul>
          </nav>

          <div data-id="element-145" data-mp="cw33b0262240">
            <h2 className="text-xs font-bold uppercase tracking-[0.14em] text-charcoal-400" data-id="element-146" data-mp="qti04pur1c60">
              Contact
            </h2>
            <ul className="mt-5 space-y-3" data-id="element-147" data-mp="msy1tiyfw2ia">
              <li className="flex items-center gap-3 text-[15px] text-charcoal-200" data-id="element-148" data-mp="mpts6627gek8">
                <MapPinIcon className="h-4 w-4 shrink-0 text-cobalt-300" aria-hidden="true" data-id="element-149" data-mp="twxsjd47hgaw" />
                {company.location}
              </li>
              <li className="flex items-center gap-3" data-id="element-150" data-mp="13rzkegpv8wh6">
                <PhoneIcon className="h-4 w-4 shrink-0 text-cobalt-300" aria-hidden="true" data-id="element-151" data-mp="18k943f0e10b0" />
                <a href={company.phoneHref} className="text-[15px] font-semibold text-charcoal-200 transition-colors duration-150 ease-out hover:text-white" data-id="element-152" data-mp="1clch7tr1wi8j">
                  {company.phoneDisplay}
                </a>
              </li>
              <li className="flex items-center gap-3" data-id="element-153" data-mp="1rid49jyarp0o">
                <MailIcon className="h-4 w-4 shrink-0 text-cobalt-300" aria-hidden="true" data-id="element-154" data-mp="3obok97g5r3dc" />
                <a href={company.emailHref} className="break-all text-[15px] font-semibold text-charcoal-200 transition-colors duration-150 ease-out hover:text-white" data-id="element-155" data-mp="3tai21c2h9gjb">
                  {company.email}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <p className="pt-7 text-sm text-charcoal-400" data-id="element-156" data-mp="1wnyzr6y5v9i9">
          &copy; CoPro Services. All Rights Reserved.
        </p>
      </div>
    </footer>;
}